import { IScope } from "angular";

export interface ITestConnectionScope extends IScope {
  link: string;
}

export interface ITestConnectionParams {
  confirmationUrl: string;
}

export class TestConnectionCtrl {
  public static $inject = ["$scope", "$stateParams"];

  constructor(private $scope: ITestConnectionScope, private $stateParams: ITestConnectionParams) {
    this.$scope.link = decodeURIComponent(this.$stateParams.confirmationUrl);
  }
}
